import { toastr } from "react-redux-toastr";

let options = {
  timeOut: 5000,
  showCloseButton: true,
  progressBar: false,
  position: "top-center",
  newestOnTop: true,
  transitionIn: "fadeIn",
  transitionOut: "fadeOut",
};

export const showToast = (title, msg, type, callbackClear) => {
  const toastrInstance =
    type === "info"
      ? toastr.info
      : type === "warning"
      ? toastr.warning
      : type === "danger"
      ? toastr.error
      : toastr.success;
  const t = toastrInstance(title, msg, options);
  callbackClear && callbackClear();
  return t;
};
